import { EventHandler, FC, MouseEvent as ReactMouseEvent, useRef } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import {
  MyLinkClickHandler,
  MyLinkSiteActivityProps,
  MyLinkSiteActivityPropsV2,
  sendLinkSiteActivity
} from './MyLink'

export type MyInternalLinkProps = Omit<LinkProps, 'onClick'> & {
  onClick?: MyLinkClickHandler
  siteActivityProps?: MyLinkSiteActivityProps | MyLinkSiteActivityPropsV2
}

export const MyInternalLink: FC<MyInternalLinkProps> = ({
  siteActivityProps,
  onClick,
  ...props
}) => {
  const pathname =
    (typeof props.to === 'object' && props.to.pathname) || (props.to as string)

  const ref = useRef<HTMLAnchorElement>(null)
  const handleClick: EventHandler<
    ReactMouseEvent<HTMLAnchorElement, MouseEvent>
  > = (event) => {
    sendLinkSiteActivity(siteActivityProps)
    onClick?.({
      linkUrl: buildAbsoluteMedicareMyUrl(pathname),
      linkText: ref.current?.innerText
    })
  }

  return <Link ref={ref} onClick={handleClick} {...props} />
}
